import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import addVisibilityObserver from '@/js/components/useVisibilityObserver';
import BaseComponent from './baseComponent';

gsap.registerPlugin(ScrollTrigger);

export default class ContentBenefitsStackedCards extends BaseComponent {
  /**
   * Public constructor
   *
   * @param options
   */
  constructor(options) {
    super(options);
    this.el = document.querySelector('[data-content-benefits-stacked-cards]');
    this.debug = false;

    if (this.el) {
      this.intro = this.el.querySelector('.intro');
      this.background = this.el.querySelector('.background');
      this.backgroundForeground = this.el.querySelector('.background > .image.-foreground');
      this.isVida = this.el.dataset.contentBenefitsStackedCards === 'vida';
    }
  }

  init() {
    if (!this.el) {
      return;
    }

    addVisibilityObserver(this.el, {
      onFirstEnter: () => {
        console.log('ContentBenefitsStackedCards initialised');
        this.animation();
      },
    }, {
      threshold: 0,
    });
  }

  animation() {
    const mm = gsap.matchMedia();

    mm.add('(max-width: 991px)', () => {
      this.el.classList.remove('-animated-version');
    });

    // The following scroll-animation only runs on viewport large
    mm.add('(min-width: 992px)', () => {
      this.el.classList.add('-animated-version');

      const items = [...this.el.querySelectorAll('.item')];
      const itemCount = items.length;
      const duration = 1000 + (itemCount * 333); // 1000 for intro + 333 per card

      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: this.el,
          markers: this.debug,
          start: 'top top',
          end: () => `+=${duration}`,
          pin: true,
          pinSpacing: true,
          scrub: 0.5, // true or seconds
        },
      });

      // Intro animation
      if (this.isVida) {
        // Vida Timeline
        timeline
          .from(this.intro, { opacity: 0, translateY: 40, duration: 5 })
          .from(this.backgroundForeground, { translateY: '10vh', duration: 5 }, '<-1')
          .to(this.intro, { opacity: 0, duration: 5 }, '+=10') // How long the text will be visible
          .to(this.background, { filter: 'blur(30px)', scale: 1.1, duration: 23 }, '<-6');
      } else {
        // Auda Timeline
        timeline
          .from(this.intro, { opacity: 0, translateY: 40, duration: 5 })
          .from(this.backgroundForeground, { translateY: '10vh', duration: 5 }, '<-1')
          .to(this.intro, { opacity: 0, duration: 5 }, '+=10') // How long the text will be visible
          .to(this.background, { filter: 'blur(30px)', scale: 1.1, duration: 23 }, '<-6');
      }

      items.forEach((item, index) => {
        const position = (index === 0) ? '<-3' : '<'; // First one needs to start earlier

        timeline
          .from(item, { translateY: '100vh', duration: 20 }, position)
          .to(item.querySelector('.image'), { scale: 1.5, duration: 16 }, '<+4');

        // Scale down if not last item
        if (index < (itemCount - 1)) {
          timeline.to(item, { scale: 0.95, duration: 20 });
        }
      });

      // Extra/empty space at the end of the scroll experience
      timeline.to({}, { duration: 5 });

      ScrollTrigger.refresh();
    });

    return this;
  }
}
